export default __webpack_public_path__ + "static/media/F0000.7d35244e.png";